$(function () {
    "use strict";
    var Engine = {
        ui: {
            navSelectedState: function () {
                $(".site-nav__utility > ul > li > a").each(function () {
                    var $this = $(this);
                    if ($this.attr('href') === window.location.pathname + window.location.search || $this.attr('href') === window.location.href) {
                        $this.addClass('selected').parents('li').addClass('selected');
                    }
                });
            }, // end navSelectedState
            mobileNav: function() {
                $('.nav-toggle').on('click', function() {
                    $('body').toggleClass('nav--open');
                });
            } // end mobileNav
        } // end ui
    };
    Engine.ui.navSelectedState();
    Engine.ui.mobileNav();
});